import { FC } from "react";
import { observer } from "mobx-react-lite";

import promoLogo from "@/assets/icons/promoLogo.png";
import { Button } from "@/components/Button";
import capybaraMultipilers from "@/assets/capybara-images/MulripliersInfo.png";
import styles from "./styles.module.sass";
import { DialogComponents } from "@/components/Dialog";

type PromoMoneyBagProps = {
  isOpen: boolean;
  onClose: VoidFunction;
  onAction: VoidFunction;
};

export const PromoMoneyBag: FC<PromoMoneyBagProps> = observer(
  ({ isOpen, onClose, onAction }) => {
    return (
      <DialogComponents.Container
        overlayClassName={styles.modalOverlay}
        wrapperClassName={styles.modalContentWrapper}
        isOpen={Boolean(isOpen)}
        onAction={onAction}
        onClose={onClose}
      >
        {({ handleClose }) => (
          <DialogComponents.Content className={styles.modalContent}>
            <DialogComponents.Closer
              className={styles.modalCloser}
              onClick={handleClose}
            ></DialogComponents.Closer>
            <div className={styles.capybag}>
              <img
                alt="capybag"
                src={promoLogo}
                style={{ maxWidth: "150px" }}
              />
            </div>
            <DialogComponents.TextContainer className={styles.textContainer}>
              <DialogComponents.Title className={styles.modalTitle}>
                {`Get ready for the BIG EVENT!`}
              </DialogComponents.Title>
              <DialogComponents.Text className={styles.modalText}>
                <span
                  style={{
                    lineHeight: "20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <p>
                    <span style={{ fontWeight: 700 }}>The Big Event </span>is
                    almost here!
                    <br /> To maximize your reward:
                  </p>
                  <p>
                    <span style={{ fontWeight: 700 }}>
                      1. Mint & Open Money Bags:
                    </span>{" "}
                    The more <br /> bags you open, the bigger your reward
                    <br />
                    for the BIG EVENT!💰
                  </p>
                  <img
                    style={{
                      width: "100%",
                      paddingTop: "6px",
                    }}
                    src={capybaraMultipilers}
                    alt=""
                  />
                  <p>
                    <span style={{ fontWeight: 700 }}>
                      2. Regularly Update your Player Card NFT <br />
                    </span>
                    to record your latest balance on-chain before the snapshot
                    time!
                  </p>
                </span>
              </DialogComponents.Text>
            </DialogComponents.TextContainer>
            <div style={{ width: "100%" }}>
              <Button
                onClick={onAction}
                label="Mint Money Bag"
                styleType="primary"
                block={true}
              ></Button>
            </div>
          </DialogComponents.Content>
        )}
      </DialogComponents.Container>
    );
  }
);
